import { match, P } from 'ts-pattern'
import type { GenerationModelType } from 'src/services/apollo/generated/graphql'
import type { DynamicTrainLoraModels } from 'src/services/constants'

export const MAX_ALLOWED_TRAIN_LORA_MEDIA = 100

export function areTrainingTaskImagesReady(itemIds: string[]) {
  if (itemIds.length > MAX_ALLOWED_TRAIN_LORA_MEDIA) return false
  if (itemIds.some(v => v.startsWith('upload'))) return false
  return true
}

type PricesByModelType = NonNullable<
  DynamicTrainLoraModels['pricing']
>['pricesByModelType']

export function getTrainingTaskPrice(args: {
  prices?: PricesByModelType
  modelType?: GenerationModelType
  datasetId?: string
  primaryLoraModelId?: string
  isFreeToTrain?: boolean
}) {
  const { prices, modelType } = args

  const priceForModel = modelType ? prices?.[modelType] : undefined
  if (!priceForModel) return 0

  const price = match(args)
    .with({ isFreeToTrain: true }, () => 0)
    .with({ datasetId: P.string }, () => priceForModel.reuse)
    .with({ primaryLoraModelId: P.string }, () => priceForModel.retrain)
    .otherwise(() => priceForModel.price)
  return price ?? 0
}
